// import Vue from "vue";

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
global.moment = require('moment');


// require('bootstrap');
// // require('bootstrap-select');

// require('tempusdominus-bootstrap-4');
import { createApp } from 'vue';
// window.Vue = require('vue');
import vSelect from 'vue-select'
const app = createApp({});

app.component('example-component', require('./components/ExampleComponent.vue').default);

$(document).on("ready", function () {
    // will first fade out the loading animation
    jQuery("#loader").fadeOut();
    // will fade out the whole DIV that covers the website.
    jQuery("#preloader").delay(500).fadeOut("slow");
});
if(document.getElementById('simule-app')) {
    // const app = new Vue({
    //     el: '#simule-app'
    // });

    const simuleApp = createApp({});
    simuleApp.component('simulator-component', require('./components/SimulatorComponent.vue').default);

    simuleApp.mount("#simule-app");

    

}


function showLoading() {
    toastr.info('Carregando...');
    // $('.loading-spinner').show();
    // $('.loading-modal').modal('show');
    // $('.loading-modal').on('shown.bs.modal', function(){

    //     setTimeout(() => {
    //         $('.loading-modal').modal('hide');
    //     }, 5000);

    // });
}

function hideLoading() {
    $('.loading-modal').modal('hide');
    // $('.loading-spinner').hide();
    // console.log('hidee', $('.loading-modal'));
    // $('.loading-modal').removeClass('show');
    // $('.loading-modal').removeClass('show');
    // $('.modal-backdrop').removeClass('show');
    // setTimeout(function(){
    //     $('.loading-modal').modal('hide');
    // }, 500);
    // console.log('on hide inside showloading');
    // });
}


$(document).ready(function(){
    $('.my-custom-select').selectpicker();

    $('.customer-logos').slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        autoplay: false,
        infinite: false,
        autoplaySpeed: 1500,
        arrows: true,
        dots: false,
        pauseOnHover: false,
        //prevArrow: '<i class="slick-prev fas fa-angle-left"></i>',
        //nextArrow: '<i class="slick-next fas fa-angle-right"></i>',
        prevArrow: '<i class="slick-prev"><span class="iconify arrowButton" data-icon="grommet-icons:form-previous"></span></i>',
        nextArrow: '<i class="slick-next"><span class="iconify arrowButton" data-icon="grommet-icons:form-next""></span></i>',
        responsive: [
            {
                breakpoint: 320,
                settings: {
                    slidesToShow: 1
                }
            },{
            breakpoint: 550,
            settings: {
                slidesToShow: 1
            }
        }, {
            breakpoint: 1000,
            settings: {
                slidesToShow: 3
            }
        }, {
            breakpoint: 1660,
            settings: {
                slidesToShow: 5
            }
        }, {
            breakpoint: 1440,
            settings: {
                slidesToShow: 4
            }
        }, {
            breakpoint: 5000,
            settings: {
                slidesToShow: 5
            }
        }]
    });


    var SPMaskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
        },
        spOptions = {
            onKeyPress: function (val, e, field, options) {
                field.mask(SPMaskBehavior.apply({}, arguments), options);
            }
        };

    $('.telphone_mask').mask(SPMaskBehavior, spOptions);
    $(".cpf").mask('000.000.000-00');
    $(".cnpj").mask('00.000.000/0000-00');
    $(".date_mask").mask('00/00/0000');
    $(".cep_mask").mask('00000-000');

});